import React from 'react';
import { amenitiesData } from '../mockData';
import { Check } from 'lucide-react';

const Amenities = () => {
  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 text-center mb-16">
          {amenitiesData.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {amenitiesData.items.map((item, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 group"
            >
              <div className="flex-shrink-0 mt-1">
                <div className="w-6 h-6 bg-black rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                  <Check size={16} className="text-white" />
                </div>
              </div>
              <p className="text-lg text-gray-800">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Amenities;